var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77614 15.6724L7.57552 19.6532L3.87717 22.463L0 15.6282L8.09072 1.53711L11.8788 4.13727L12.0037 8.35203L11.9679 8.37261L7.77614 15.6724Z",
    fill: "#28B446"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09058 1.53711L10.3929 11.1153L12.0035 8.35203L11.8786 2.80386L8.09058 1.53711Z",
    fill: "#219B38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9085 1.53711L23.9999 15.6282L19.6366 17.8349L16.1813 15.6493V15.6282L12.0035 8.35203L8.09058 1.53711H15.9085Z",
    fill: "#FFD837"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.6289L20.1253 22.4195L3.8772 22.4638L7.77617 15.6732L16.1815 15.6501L24 15.6289Z",
    fill: "#518EF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8772 22.4627L10.6758 15.6641L7.77617 15.672L3.8772 22.4627Z",
    fill: "#3A5BBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 15.6272L15.1294 13.7949L16.1815 15.6484L24 15.6272Z",
    fill: "#FBBB00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDrive);
export default __webpack_public_path__ + "static/media/googleDrive.bd27ae15.svg";
export { ForwardRef as ReactComponent };